import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AgGridSetValuesQueryVariables = Types.Exact<{
  gridId: Types.Scalars['String']['input'];
  colId: Types.Scalars['String']['input'];
  request: Types.GridRequestInput;
}>;


export type AgGridSetValuesQuery = { __typename?: 'Query', agGridSetValues: { __typename?: 'AgGridSetValuesResult', values: Array<unknown> } };


export const AgGridSetValuesDocument = new TypedDocumentString(`
    query AgGridSetValues($gridId: String!, $colId: String!, $request: GridRequestInput!) {
  agGridSetValues(gridId: $gridId, colId: $colId, request: $request) {
    values
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AgGridSetValues: build.query<AgGridSetValuesQuery, AgGridSetValuesQueryVariables>({
      query: (variables) => ({ document: AgGridSetValuesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAgGridSetValuesQuery, useLazyAgGridSetValuesQuery } = injectedRtkApi;
